import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetAuftragMutation, useGetHinweiseMutation, useGetHistoriePrivateMutation, useSpeicherAuftragMutation } from "../../api/AuftragAPI";
import { setModalMessageOkDialogVisible } from "../../Slice/DialogSlice";
import { AppDispatch } from "../../Store";
import { IAuftrag, IAuftraggeber, IAuftragHinweisResponse, IAuftragHistorie, IAuftragRequest } from "../../types/Types";
import { formatToEuroDateTime } from "../../util/DateUtils";
import AuftragMessageComponent from "../chat/AuftragMessageComponent/AuftragMessageComponent";
import { LoadingModal } from "../LoadingModal/LoadingModal";
import MapComponent, { ILocation } from "../MapComponent/MapComponent";
import UploadToServer from "../UploadComponent/UploadToServer";
import stylesDetails from './auftragdetailcomponent.module.scss';
import HinweisComponent from "../HinweisComponent";

const emptyAuftraggeber: IAuftraggeber = {
  name: '',
  uid: '',
  rechnungsempfaenger: null,
}

const emptyAuftrag: IAuftrag = {
  uid: '',
  art: '',
  status: '',
  createDate: new Date(),
  aktuellerTermin: null,
  wiedervorlage: null,
  auftraggeber: emptyAuftraggeber,
  vorname_endkunde: '',
  name_endkunde: '',
  strasse_lieferadresse: '',
  hausnummer_lieferadresse: '',
  postleitzahl_lieferadresse: '',
  stadt_lieferadresse: '',
  land_lieferadresse: '',
  telefon_lieferadresse: '',
  mobil1_lieferadresse: '',
  mobil2_lieferadresse: '',
  email_lieferadresse: '',
  spaetmesstermin: null,
  besonderheiten: '',
  messzeitpunkt: '',
  name_ansprechpartner: '',
  kontakt_ansprechpartner: '',
  email_ansprechpartner: '',
  auftragsnr_ag: '',
  ausfuehrungvon: null,
  colorAuftrag: '#4285F4',
  colorProfile: '#000000',
  lat: 0,
  lng: 0,
  angepinnt: false,
  erstelltVon: {
    uid: '',
    name: '',
    calendarId: null
  },
  calendarEventId: null,
  dauerInMinuten: 0,
  bearbeiter: null,
}

type ThisProps = {
  uid: string | undefined;
  backbuttonClose: boolean;
  backbuttonVisible: boolean;
  //statusChanged: () => void;
}

/**
 * @author noone
 */
const AuftragDetailComponent: React.FC<ThisProps> = (props) => {

  const navigate = useNavigate();
  const { t } = useTranslation();

  const [speicherAuftragAPI] = useSpeicherAuftragMutation();
  const [getAuftragAPI] = useGetAuftragMutation();
  const [getAuftragHistoriePrivate] = useGetHistoriePrivateMutation();
  const [getHinweise] = useGetHinweiseMutation();

  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [spaetmesstermin, setSpaetmesstermin] = useState<string>(""); // ist nicht schön, ich weiss
  const [auftrag, setAuftrag] = useState<IAuftrag>(emptyAuftrag);
  const [historie, setHistorie] = useState<IAuftragHistorie[]>([]);
  const [hinweise, setHinweise] = useState<IAuftragHinweisResponse[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const dispatch = useDispatch<AppDispatch>();

  const locationSet = (location: ILocation) => {

    // TODO
    if (auftrag !== undefined) {
      setAuftrag((prevData) => {
        return {
          ...prevData,
          strasse_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'route')?.long_name || '',
          hausnummer_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'street_number')?.long_name || '',
          postleitzahl_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'postal_code')?.long_name || '',
          stadt_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'locality')?.long_name || '',
          land_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'country')?.long_name || '',
          lat: location.lat,
          lng: location.lng,
        };
      });
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAuftrag((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));

    if (e.target.name === "spaetmesstermin") {
      setSpaetmesstermin(e.target.value);
    }
  }

  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAuftrag((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const speichern = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    setIsLoading(true);

    const auf: IAuftragRequest = {
      uid: auftrag.uid,
      art: auftrag.art,
      vorname_endkunde: auftrag.vorname_endkunde,
      name_endkunde: auftrag.name_endkunde,
      strasse_lieferadresse: auftrag.strasse_lieferadresse,
      hausnummer_lieferadresse: auftrag.hausnummer_lieferadresse,
      postleitzahl_lieferadresse: auftrag.postleitzahl_lieferadresse,
      stadt_lieferadresse: auftrag.stadt_lieferadresse,
      land_lieferadresse: auftrag.land_lieferadresse,
      telefon_lieferadresse: auftrag.telefon_lieferadresse,
      mobil1_lieferadresse: auftrag.mobil1_lieferadresse,
      mobil2_lieferadresse: auftrag.mobil2_lieferadresse,
      email_lieferadresse: auftrag.email_lieferadresse,
      besonderheiten: auftrag.besonderheiten,
      messzeitpunkt: auftrag.messzeitpunkt,
      spaetmesstermin: auftrag.spaetmesstermin,
      auftragsnr_ag: auftrag.auftragsnr_ag,
      ansprechpartner: auftrag.name_ansprechpartner,
      kontakt_ansprechpartner: auftrag.kontakt_ansprechpartner,
      email_ansprechpartner: auftrag.email_ansprechpartner,
      lat: auftrag.lat,
      lng: auftrag.lng,
    }
    speicherAuftragAPI(auf)
      .unwrap()
      .then(() => {
        dispatch(setModalMessageOkDialogVisible({
          visible: true,
          text: 'Erfolgreich gespeichert.',
        }));
      })
      .catch((error) => console.log(error))
      .finally(() => setIsLoading(false))
      ;

  }

  useEffect(() => {
    const uid = props.uid;
    getAuftragAPI(uid!!).unwrap().then((data) => {
      setAuftrag(data);
      setIsLoaded(true);

      const formattedDate: Date | string = data?.spaetmesstermin
        ? data.spaetmesstermin
        : "";

      setSpaetmesstermin("" + formattedDate);

    });

    getAuftragHistoriePrivate(uid!!).unwrap().then((data) => setHistorie(data)).catch(() => { });

    getHinweise(uid!!).unwrap().then((data) => setHinweise(data));

  }, []);

  return (
    <>

      <LoadingModal show={isLoading} />

      <div className={stylesDetails.containerAuftragDetails} >

        {props.backbuttonVisible &&
          <>
            {props.backbuttonClose === true ?
              <button
                onClick={() => {
                  window.close();
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-danger'
              >
                <i className="bi bi-x-circle"></i> {t('deTranslation.misc.closeButton')}
              </button>
              :
              <button
                onClick={() => {
                  navigate("../", {
                    relative: "path"
                  });
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
              </button>
            }

          </>}

        <div className={stylesDetails.contentDiv}>
          {isLoaded &&
            <>
              <div>

                <form>

                  <div className="form-group">
                    {t('deTranslation.auftragDetails.auftragStatus')}:
                    <input readOnly={true} className='form-control' name="art" value={auftrag?.status} />
                  </div>

                  <div className="form-group">
                    {t('deTranslation.auftragDetails.art')}:
                    <input readOnly={true} className='form-control' name="art" value={auftrag?.art} />
                  </div>

                  <div className="form-group">
                    Auftraggeber:
                    <input readOnly={true} className='form-control' name="auftraggeber" value={auftrag?.auftraggeber.name} />
                  </div>

                  <div className="form-group">
                    Angelegt von:
                    <input readOnly={true} className='form-control' name="angelegtVon" value={auftrag?.erstelltVon.name} />
                  </div>

                  <div className="form-group">
                    Bearbeiter:
                    <input readOnly={true} className='form-control' name="bearbeiter" value={auftrag?.bearbeiter?.name} />
                  </div>

                  <div className="form-group">
                    Angelegt am:
                    <input readOnly={true} className="form-control" name="angelegtAm" value={formatToEuroDateTime(auftrag?.createDate)} ></input>
                  </div>

                  <div className="form-group">
                    Auftragsnummer Kunde:
                    <input readOnly={true} type="text" className="form-control" name="auftragsnummer_ag" value={auftrag?.auftragsnr_ag} ></input>
                  </div>

                  <div className="form-group">
                    Aktueller Termin:
                    <input readOnly={true} className="form-control" name="aktueller termin" value={formatToEuroDateTime(auftrag?.aktuellerTermin)} ></input>
                  </div>

                  <div className="form-group">
                    Termindauer in Minuten:
                    <input className="form-control" name="dauerInMinuten" value={auftrag?.dauerInMinuten} onChange={handleChange} ></input>
                  </div>

                  <div className="form-group">
                    Spätester Messtermin:
                    <input type="date" className="form-control" name="spaetmesstermin" value={spaetmesstermin} onChange={handleChange} ></input>
                  </div>

                  <div className="form-group">
                    Vorname Endkunde:
                    <input className='form-control' name="vorname_endkunde" value={auftrag?.vorname_endkunde} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    Name Endkunde oder Firma:
                    <input className='form-control' name="name_endkunde" value={auftrag?.name_endkunde} onChange={handleChange} />
                  </div>

                  <div className={stylesDetails.strasseHausnr}>

                    <div className="form-group">
                      Straße Endkunde:
                      <input className='form-control' name="strasse_lieferadresse" value={auftrag?.strasse_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Hausnummer Endkunde:
                      <input className='form-control' name="hausnummer_lieferadresse" value={auftrag?.hausnummer_lieferadresse} onChange={handleChange} />
                    </div>

                  </div>

                  <div className={stylesDetails.plzOrt}>

                    <div className="form-group">
                      Postleitzahl Lieferadresse:
                      <input className='form-control' name="postleitzahl_lieferadresse" value={auftrag?.postleitzahl_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Stadt Lieferadresse:
                      <input className='form-control' name="stadt_lieferadresse" value={auftrag?.stadt_lieferadresse} onChange={handleChange} />
                    </div>

                    {/*<div className="form-group">
                  Land lieferadresse:
                  <input className='form-control' name="land_lieferadresse" value={auftrag?.land_lieferadresse} onChange={handleChange} />
                </div>*/}
                  </div>

                  <div className={stylesDetails.kontakt}>

                    <div className="form-group">
                      Email:
                      <input className='form-control' name="email" value={auftrag?.email_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Telefon Lieferadresse:
                      <input className='form-control' name="telefon_lieferadresse" value={auftrag?.telefon_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Mobil 1:
                      <input className='form-control' name="mobil1_lieferadresse" value={auftrag?.mobil1_lieferadresse} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      Mobil 2:
                      <input className='form-control' name="mobil2_lieferadresse" value={auftrag?.mobil2_lieferadresse} onChange={handleChange} />
                    </div>

                     <div className="form-group">
                      Kontakt Ansprechpartner:
                      <input className='form-control' name="kontakt_ansprechpartner" value={auftrag?.kontakt_ansprechpartner} onChange={handleChange} />
                    </div>

                    <div className="form-group">
                      E-Mail Ansprechpartner:
                      <input className='form-control' name="email_ansprechpartner" value={auftrag?.email_ansprechpartner} onChange={handleChange} />
                    </div>

                  </div>

                  <div className="form-group">
                    Hinweise zum Aufmaß und Messzeitpunkt:
                    <textarea className='form-control' name="besonderheiten" value={auftrag?.besonderheiten} onChange={handleChangeTextArea} />
                  </div>

                  <div className="form-group" style={{ display: "none" }}>
                    Lat:
                    <input readOnly={true} className='form-control' name="lat" value={auftrag?.lat} onChange={handleChange} />
                  </div>

                  <div className="form-group" style={{ display: "none" }}>
                    Lng:
                    <input readOnly={true} className='form-control' name="lng" value={auftrag?.lng} onChange={handleChange} />
                  </div>

                  <div className="form-group">
                    <input type="submit" className='btn btn-primary' value="Speichern" onClick={speichern} />
                  </div>

                </form>

              </div>

              <div>

                <UploadToServer uid={auftrag.uid} />

                <div style={{ marginTop: "2em" }}>

                  <MapComponent onLocationSet={locationSet} startLat={auftrag.lat} startLng={auftrag.lng} scrollZoom={false} />

                </div>

                <div>

                  Historie

                  <ul>
                    {historie?.map((e, index) =>
                      <li key={index}>{(e.datum !== null) ? formatToEuroDateTime(e.datum) : "--"} {e.text!!}</li>
                    )}
                  </ul>
                </div>

                <div>

                  Hinweise

                  {hinweise?.map((e, index) => <>
                    <div key={e.uid}>{formatToEuroDateTime(e.erstelltAm)} {e.erstelltVon} {e.typ} {e.text}</div>
                  </>)}

                </div>

                {auftrag &&
                  <div>
                    <AuftragMessageComponent auftragUid={auftrag.uid} />
                  </div>
                }

                 {auftrag &&
                  <div>
                    <HinweisComponent auftragUid={auftrag.uid} />
                  </div>
                }

              </div>


            </>}
        </div>
      </div>
    </>
  );

}

export default AuftragDetailComponent;